import React from 'react';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import { Server } from '../server/server';
import HomePage from './pages/HomePage';
import SitePage from './pages/SitePage';
import GamesPage from './pages/GamesPage';
import AccountPage from './pages/AccountPage';
import LoadingPage from './pages/LoadingPage';
import InventoryPage from './pages/InventoryPage';
import ShopPage from './pages/ShopPage';
import FriendsPage from './pages/FriendsPage';
import SocialPage from './pages/SocialPage';
import PasswordPage from './pages/PasswordPage';
import GamePage from './pages/GamePage';
import HelpPage from './pages/HelpPage';
import PlayGamePage from './pages/PlayGamePage';
import MessagesPage from './pages/MessagesPage';
import ProfilePage from './pages/ProfilePage';
import MediaPage from './pages/MediaPage';
import WalletPage from './pages/WalletPage';
import StatsPage from './pages/StatsPage';
import ChatPage from './pages/ChatPage';
import NotFoundPage from './pages/NotFoundPage';
import TournamentPage from './pages/TournamentPage';
import './App.css';
import CraftingPage from './pages/CraftingPage';
import HistoryPage from './pages/HistoryPage';
import { AppConfig } from './AppConfig';

interface AppState {
  allowAccess: boolean;
  postLoginPage: string;
  initialized: boolean;
  maintenance: boolean;
};

class App extends React.Component<{}, AppState> {
  constructor(props = {}) {
    super(props);

    this.state = {
      allowAccess: this.checkSecretPassword(),
      postLoginPage: 'account',
      initialized: false,
      maintenance: false
    }

    if(!this.state.maintenance)
      Server.init();

    this.setInitialized = this.setInitialized.bind(this);
    this.checkSecretPassword = this.checkSecretPassword.bind(this);
    this.setSecretPassword = this.setSecretPassword.bind(this);
    this.onAccountChanged = this.onAccountChanged.bind(this);

    window.addEventListener("beforeunload", function (e) {
      Server.network.disconnect();
    });

  }

  componentDidMount() {
    Server.account.addEventListener('login', this.onAccountChanged);
    Server.account.addEventListener('logout', this.onAccountChanged);

    if(!this.state.maintenance)
      Server.network.setPresence('site');
  }

  setInitialized() {
    this.setState({initialized: true});
  }

  checkSecretPassword() {
    return (localStorage.getItem('secret-password') === AppConfig.secretPassword);
  }

  setSecretPassword(password:string) {
    localStorage.setItem('secret-password', password);
    this.setState({allowAccess: this.checkSecretPassword()});
  }

  onAccountChanged() {
    this.forceUpdate();
  }

  render() {
    if (!this.state.initialized)
      return (<LoadingPage maintenance={this.state.maintenance} setInitialized={this.setInitialized} />);

    if(!this.state.allowAccess)
      return (<PasswordPage setPassword={this.setSecretPassword} />);

    return (
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<SitePage />}>
            <Route index element={<HomePage />} />
            <Route path='/games' element={<GamesPage />} />
            <Route path='/game/:id' element={<GamePage />} />
            <Route path='/contest/:id' element={<TournamentPage />} />
            <Route path='/play/:id' element={<PlayGamePage />} />
            <Route path='/shop' element={<ShopPage />} />
            <Route path='/inventory' element={<InventoryPage />} />
            <Route path='/crafting' element={<CraftingPage />} />
            <Route path='/friends' element={<FriendsPage />} />
            <Route path='/messages' element={<MessagesPage />} />
            <Route path='/chat/:id' element={<ChatPage />} />
            <Route path='/profile/:id' element={<ProfilePage />} />
            <Route path='/help/:id' element={<HelpPage />} />
            <Route path='/media' element={<MediaPage />} />
            <Route path='/wallet' element={<WalletPage />} />
            <Route path='/stats' element={<StatsPage />} />
            <Route path='/history' element={<HistoryPage />} />
            <Route path='/account' element={<AccountPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    );
  }
}

export default App;
